export default "__VITE_ASSET__CCDUui6e__"